module.exports = __webpack_public_path__ + "static/media/ad-comment-upper.f3f7724d.png";